import { useState, useEffect } from 'react';
import { getActuatorId } from '../actuator-id';

export const useActuatorRegistration = ({ activate, needsActivation, actuatorProps }) => {
  const {
    registerActuator, unregisterActuator, debugMode,
  } = actuatorProps;
  const [actuatorId, setBeaconId] = useState(-1);
  useEffect(() => {
    const id = getActuatorId();
    setBeaconId(id);
    const actuator = {
      id, activate, needsActivation,
    };
    registerActuator(actuator);
    return () => {
      unregisterActuator(actuator);
    };
  }, [activate, needsActivation, registerActuator, unregisterActuator]);

  return { actuatorId, debugMode };
};
